import _zipObject from 'lodash/zipObject'
import _forEach from 'lodash/forEach'
import { fromJS, Record, List } from 'immutable'

export const TOTAL_COUNT_HEADER = "X-Results-Total-Count"
export const PAGE_INFO_HEADER = "X-Page-Info"
export const CURSOR_PREFIX = "next="
export const HAS_MORE_PREFIX = "hasMore="

export const PageInfo = Record({
  id: undefined,
  page: 1,
})

export const BidirectionalPagedData = Record({
  data: List(),
  cursor: undefined,
  hasNext: undefined,
  hasPrevious: undefined,
  total: undefined,
})

export const PagedData = Record({
  data: List(),
  cursor: undefined,
  hasMore: undefined,
  status: undefined,
  total: undefined,
})

export const parseBidirectionalPagedData = (parse = fromJS) => ({ response, xhr }) => {
  const totalCountInfo = xhr.getResponseHeader(TOTAL_COUNT_HEADER)
  const pageInfo = xhr.getResponseHeader(PAGE_INFO_HEADER)

  return BidirectionalPagedData({ data: parse(response), ...getBidirectionalPagingData(pageInfo, totalCountInfo) })
}

export function combinePagedData(current, next) {
  return current.withMutations(_current => _current
    .update('data', data => data.concat(next.data))
    .set('cursor', next.cursor)
    .set('hasNext', next.hasNext)
    .set('hasPrevious', next.hasPrevious)
  )
}

export const parsePagedData = (parse = fromJS) => ({ response, xhr }) => {
  return PagedData({ data: parse(response), ...getPagingData(xhr) })
}

export function getTotalCount(totalCountInfo) {
  return {
    total: parseInt(totalCountInfo)
  }
}

export function getPagingData(xhr) {
  const totalCountInfo = xhr.getResponseHeader(TOTAL_COUNT_HEADER)
  const pageInfo = xhr.getResponseHeader(PAGE_INFO_HEADER)
  const data = pageInfo.split(',')

  if (data.length === 1) {
    return {
      hasMore: data[0].substr(HAS_MORE_PREFIX.length) === "true",
      ...getTotalCount(totalCountInfo),
    }
  } else {
    return {
      cursor: data[0].substr(CURSOR_PREFIX.length),
      hasMore: data[1].substr(HAS_MORE_PREFIX.length) === "true",
      ...getTotalCount(totalCountInfo),
    }
  }
}

export function getBidirectionalPagingData(pageInfo, totalCountInfo) {
  if (!pageInfo) {
    return getTotalCount(totalCountInfo)
  }

  const pagingData = castBooleans(_zipObject(pageInfo.split(',').map(record => record.split("="))), ['hasNext', 'hasPrevious'])

  return {
    ...pagingData,
    ...getTotalCount(totalCountInfo)
  }
}

function castBooleans(data, keys) {
  return _forEach(data, (value, key) => {
    if (keys.includes(key)) {
      data[key] = value === "true"
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/utils/paging.js